export default "__VITE_ASSET__Dsw57Bvw__"